import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Bookings")
  ])
], -1)
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-striped table-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Booking #"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "End Time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Require/Availabe Slot"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, " Drivers "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "bussiness"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "User"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1)
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "btn-group mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bookings, (booking) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: booking.id
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(booking.id), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(booking.booking_number), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString($options.dateTime(booking.start_time)), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString($options.dateTime(booking.end_time)), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(booking.country?.currency_short_name) + " " + _toDisplayString(booking.total), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(booking.number_of_rider) + "/" + _toDisplayString(booking.available_slot), 1),
                    _createElementVNode("td", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.booking_riders, (booking_rider) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: booking_rider.id
                        }, [
                          _createElementVNode("a", {
                            href: `/drivers/${booking_rider.driver?.id}/detail`
                          }, _toDisplayString(booking_rider.driver.rider_name), 9, _hoisted_16),
                          _createTextVNode(),
                          _hoisted_17
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(booking.bussiness_name), 1),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("a", {
                        href: `/users/${booking.user?.id}/view`
                      }, _toDisplayString(booking.user?.full_name), 9, _hoisted_20)
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          to: `/bookings/${booking.id}/view`,
                          class: "btn btn-sm btn-success me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Detail")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}